
import { Cookies } from 'react-cookie';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// import { fetchJSON } from '../../helpers/api';
import * as API from '../api';

import { LOGIN_USER, LOGOUT_USER, REGISTER_USER, FORGET_PASSWORD } from './constants';
import { CLEAR_MENU } from '../appMenu/constants';

import {
    loginUserSuccess,
    loginUserFailed,
    registerUserSuccess,
    registerUserFailed,
    forgetPasswordSuccess,
    forgetPasswordFailed,
} from './actions';

import { clearMenu } from '../appMenu/actions';

/**
 * Sets the session
 * @param {*} user
 */
const setSession = (user, tokens = null) => {
    let cookies = new Cookies();
    if (user) {
        cookies.set('user', JSON.stringify(user), { path: '/' });
        cookies.set('tokens', JSON.stringify(tokens), { path: '/' });
    } else {
        cookies.remove('user', { path: '/' });
        cookies.remove('tokens', { path: '/' });
    }
};
/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { email, password } }) {
    try {
        const response = yield call(API.login, { email, password });
        if (response.ok) {
            setSession(response.data.user, response.data.tokens);
            yield put(loginUserSuccess(response));
        } else {
            yield put(loginUserFailed(response.data.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error.message;
        }
        yield put(loginUserFailed(message));
        setSession(null);
    }
}

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { navigate } }) {
    try {
        setSession(null);
        // Clear menu state when logging out
        yield put(clearMenu());
        yield call(() => {
            navigate('/account/login');
        });
    } catch (error) {}
}

/**
 * Register the user
 */
function* register({ payload }) {
    try {
        const response = yield call(API.createUser, payload);
        if (response.ok) {
            setSession(response.data.user, response.data.tokens);
            yield put(registerUserSuccess(response.data.user));
        } else {
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error.message;
        }
        yield put(registerUserFailed(message));
    }
}

/**
 * forget password
 */
function* forgetPassword({ payload: { email } }) {
    try {
        const response = yield call(API.forgetPassword, { email });
        if (response.ok) {
            yield put(forgetPasswordSuccess(response.data.message));
        } else {
            yield put(forgetPasswordFailed(response.data.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error.message;
        }
        yield put(forgetPasswordFailed(message));
    }
}

export function* watchUserLogin() {
    yield takeEvery(LOGIN_USER, login);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logout);
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, register);
}

export function* watchUserForgetPassword() {
    yield takeEvery(FORGET_PASSWORD, forgetPassword);
}

function* authSaga() {
    yield all([fork(watchUserLogin), fork(watchUserLogout), fork(watchUserRegister), fork(watchUserForgetPassword)]);
}

export default authSaga;
